import { render } from "./App.vue?vue&type=template&id=4bd40e38"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4bd40e38&lang=css"

import exportComponent from "/Users/walt/WORK/school/portfolio/s1-crypto-prng/prng/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__